import { useCardStyles } from './cardStyles';
import { humanState, useEntity, useEntityFriendlyName } from './useEntity';
import { domainIcon } from './icons';
import { domainForEntityId } from './EntityCard';

export interface GenericEntityCardProps {
  entityId: string;
  title?: string;
}

const TONE_COLOR: Record<string, string> = {
  on: 'text-emerald-500 dark:text-emerald-400',
  off: 'text-gray-400 dark:text-gray-500',
  warn: 'text-amber-500 dark:text-amber-400',
  muted: 'text-gray-400 dark:text-gray-500',
};

export function GenericEntityCard({ entityId, title }: GenericEntityCardProps): JSX.Element {
  const styles = useCardStyles();
  const entity = useEntity(entityId);
  const name = useEntityFriendlyName(entityId, title);
  const s = humanState(entity);
  const toneClass = TONE_COLOR[s.tone];
  const domain = domainForEntityId(entityId);
  const Icon = domainIcon(domain);

  return (
    <div
      className={styles.container}
      data-domain={domain}
      data-entity-id={entityId}
      data-state={entity?.state ?? 'unknown'}
    >
      <div className="flex items-center justify-between">
        <div
          className={`flex h-9 w-9 items-center justify-center rounded-xl ${
            styles.isDark ? 'bg-gray-700/60 text-gray-300' : 'bg-gray-100 text-gray-500'
          }`}
        >
          <Icon className="h-5 w-5" />
        </div>
      </div>
      <div>
        <div className={`truncate text-sm font-medium ${styles.title}`}>{name}</div>
        <div className={`text-lg font-bold tabular-nums ${toneClass}`}>{s.text}</div>
      </div>
    </div>
  );
}
